export default __webpack_public_path__ + "1871b6641d418cb69f57fcab73505867.svg";